import { render, staticRenderFns } from "./TheadTbody.vue?vue&type=template&id=4b13fad0&scoped=true&"
import script from "./TheadTbody.vue?vue&type=script&lang=js&"
export * from "./TheadTbody.vue?vue&type=script&lang=js&"
import style0 from "./TheadTbody.vue?vue&type=style&index=0&id=4b13fad0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b13fad0",
  null
  
)

export default component.exports